export const siteFooter = [
  {
    text: "Términos y condiciones",
    href: "https://e.peruquiosco.pe/site/file/terminos_condiciones_pq.pdf?v1616353629",
  },
  {
    text: "Políticas y Cookies",
    href: "https://e.peruquiosco.pe/site/file/politica_cookies.pdf?v1616353629",
  },
  {
    text: "Libro de Reclamaciones",
    href: "http://ecomedia.pe/libro/inicio/elcomercio/",
  },
  // {
  //   text: "Preguntas Frecuentes",
  //   href: "https://peruquiosco.pe/preguntas-frecuentes",
  // },
  {
    text: "Lo nuevo en PerúQuiosco",
    href: "/",
  },
];
